import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  const [data, setData] = useState({ username: "", password: "" });
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user")) || null;
    if(user){
      if(user.accessToken && user.userRole[0] === "VENDOR"){
        navigate("/vendor/dashboard");
      } else if(user.accessToken && user.userRole[0] === "ADMIN"){
        navigate("/admin");
      } else if(user.accessToken && user.userRole[0] === "SUPERADMIN"){
        navigate("/superadmin-dashboard");
      } else if(user.accessToken){
        navigate("/dashboard");
      } 
    }
  }, [])

  // Management roles definition
  const managementRoles = ['PURCHASE_HEAD', 'PURCHASE_MANAGER', 'COO', 'CFO', 'CEO', 'CMD'];

  // AUTOMATIC REDIRECT REMOVED TO ENSURE LOGIN PAGE SHOWS FIRST

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/signin`,
        { username: data.username, password: data.password }
      );

      const user = res.data;
      const role = user.userRole[0];

      // Redirection logic stays only within the login button trigger
      if (role === "SUPERADMIN") {
        navigate("/superadmin-dashboard");
      } else if (role === "ADMIN") {
        const org = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${user.username}`,
          { headers: { Authorization: `Bearer ${user.accessToken}` } }
        );
        localStorage.setItem("org", JSON.stringify(org.data.orgId));
        if (!org.data.orgUsername && !org.data.orgShortform) {
          navigate(`/admin/org-details`);
        } else {
          navigate(`/admin`);
        }
      } else if (role === "VENDOR") {
        navigate("/vendor/dashboard");
      } else if (role === "BUYER") {
        navigate("/buyer");
      } else if (managementRoles.includes(role)) {
        navigate("/dashboard");
      } else {
        navigate("/dashboard");
      }

      localStorage.setItem("user", JSON.stringify(user));
    } catch (error) {
      setError("Login failed. Invalid user ID or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App" style={{ position: 'relative' }}>
      {loading && <div className="loading-div"></div>}
      <div className="border-container">
        <form>
          <Typography variant="h4" mb={5}>
            Login
          </Typography>
          <label htmlFor="username">Email ID</label>
          <input
            type="email"
            name="username"
            id="username"
            onChange={handleChange}
          />
          <label htmlFor="password">Password</label>
          <input
            type="password"
            name="password"
            id="password"
            onChange={handleChange}
          />
          {error && <span className="error">{error}</span>}
          <div style={{ display: "flex", justifyContent: "end" }}>
            <a href="/forgot-password" style={{ fontSize: "12px" }}>
              Forgot Password?
            </a>
          </div>
          <button 
            type="button" 
            className="btn-contained" 
            style={{ width: '100%', marginTop: '20px', height: '40px', cursor: 'pointer' }} 
            onClick={handleLogin} 
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
        <Box sx={{ display: "flex", justifyContent: "space-between", width: "30%", mt: 2 }}>
          <Box>
            <Link to={"/signup"} style={{ fontSize: "12px" }}>
              Sign Up As Vendor
            </Link>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default Login;